import {
  getDispatchOriginsByMissionId,
  getDispatchOriginStopId,
} from "./selectors";
import DispatchOriginsSlice from "./reducers";

// actions
export const { recordDispatchOrigin, clearDispatchOrigin } =
  DispatchOriginsSlice.actions;

// selectors
export { getDispatchOriginsByMissionId, getDispatchOriginStopId };

// reducer
export default DispatchOriginsSlice.reducer;
